<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rulesComputed"
    label-width="100px"
    class="statrgy-manager-form"
  >
    <el-form-item
      label="策略渠道"
      prop="sourceType"
    >
      <el-radio-group
        v-model="form.sourceType"
        @change="sourceTypeChange"
      >
        <el-radio
          v-for="type in sourceTypeList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="策略名称"
      prop="strategyName"
    >
      <el-input
        v-model="form.strategyName"
        placeholder="策略名称"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.sourceType==3"
      label="策略来源"
      prop="sourceId"
    >
      <el-input
        v-model="form.sourceId"
        placeholder="策略来源"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="策略来源"
      prop="sourceId"
      v-else
    >
      <el-select
        style="width: 100%"
        v-model="form.sourceId"
        clearable
        placeholder="策略来源"
        @change="sourceSelectChange"
      >
        <el-option
          v-for="item in strategySourceList"
          :key="getStrategySourceValue(item)"
          :label="getStrategySourceLable(item)"
          :value="getStrategySourceValue(item)"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="form.sourceType === 5 ? '会话ID' : form.sourceType === 6 ? '群聊' : '策略作者'"
      prop="authorId"
    >
      <el-popover
        v-if="form.sourceType === 5"
        v-model="telegramChatCandidatesVisible"
        placement="bottom-start"
        popper-class="telegram-candidate-popper"
        trigger="click"
        @show="resetTelegramChatCandidateMenu"
      >
        <el-cascader-panel
          :key="telegramChatCascaderKey"
          ref="telegramChatCascader"
          :options="telegramChatCandidateTypes"
          :props="telegramChatCascaderProps"
          @change="telegramChatCascaderSelect"
        ></el-cascader-panel>
        <el-input
          slot="reference"
          :value="telegramChatEditing || telegramChatCandidatesVisible ? form.authorId : telegramChatDisplayText"
          placeholder="选择候选会话或输入Telegram chat ID"
          @change="telegramChatChange"
          @focus="telegramChatEditing = true"
          @blur="telegramChatEditing = false"
          @input="telegramChatInputChange"
        ></el-input>
      </el-popover>
      <el-popover
        v-else-if="form.sourceType === 6"
        v-model="larkChatCandidatesVisible"
        placement="bottom-start"
        popper-class="lark-candidate-popper"
        trigger="click"
        width="420"
        @show="resetLarkChatCandidates"
      >
        <div v-if="larkCandidateChats.length" class="telegram-candidate-list">
          <el-button
            v-for="item in larkCandidateChats"
            :key="item.chat_id"
            class="telegram-candidate-option"
            type="text"
            @click="selectLarkChat(item)"
          >{{getLarkChatLabel(item)}}</el-button>
        </div>
        <div v-else class="form-tip">{{larkChatLoading ? '加载中...' : '暂无候选群聊，可直接输入oc_开头的群chat_id'}}</div>
        <el-button
          v-if="larkChatHasMore"
          :disabled="larkChatLoading"
          type="text"
          @click="loadLarkChats"
        >加载更多</el-button>
        <el-input
          slot="reference"
          :value="larkChatEditing || larkChatCandidatesVisible ? form.authorId : larkChatDisplayText"
          placeholder="选择群聊或输入oc_开头的群chat_id"
          @change="larkChatChange"
          @focus="larkChatEditing = true"
          @blur="larkChatEditing = false"
          @input="larkChatInputChange"
        ></el-input>
      </el-popover>
      <el-input
        v-else-if="form.sourceType >=3"
        v-model="form.authorId"
        placeholder="策略作者"
      ></el-input>
      <el-select
        v-else
        style="width: 100%"
        v-model="form.authorId"
        clearable
        placeholder="策略作者"
      >
        <el-option
          v-for="(item,index) in authorList"
          :key="index"
          :label="getAuthorLable(item)"
          :value="getAuthorValue(item)"
        ></el-option>
      </el-select>
      <div v-if="form.sourceType === 5" class="form-tip">私聊会话ID即为用户ID</div>
      <div v-if="form.sourceType === 6" class="form-tip">仅支持群聊，chat_id以oc_开头</div>
    </el-form-item>
    <el-form-item
      v-if="form.sourceType === 5 && !isSelectedPrivateTelegramChat()"
      label="成员白名单"
      prop="telegramMemberIds"
    >
      <el-popover
        ref="telegramMemberCandidatesPopover"
        v-model="telegramMemberCandidatesVisible"
        placement="bottom-start"
        popper-class="telegram-candidate-popper"
        trigger="click"
        width="420"
      >
        <div v-if="telegramCandidateMembers.length" class="telegram-candidate-list">
          <el-button
            v-for="item in telegramCandidateMembers"
            :key="item.id"
            class="telegram-candidate-option"
            type="text"
            @click="addTelegramMember(item.userId)"
          >{{getTelegramMemberLabel(item)}}</el-button>
        </div>
        <div v-else class="form-tip">暂无候选成员，可直接输入用户ID</div>
        <el-input
          ref="telegramMemberInput"
          slot="reference"
          :value="telegramMemberEditing || telegramMemberCandidatesVisible ? form.telegramMemberIds : telegramMemberDisplayText"
          :autosize="{ minRows: 1, maxRows: 4 }"
          placeholder="选择候选成员，或每行、空格、逗号分隔输入Telegram用户ID"
          type="textarea"
          @focus="telegramMemberEditing = true"
          @blur="telegramMemberEditing = false"
          @input="telegramMemberInputChange"
        ></el-input>
      </el-popover>
      <div class="form-tip">留空表示群组全量采集；私聊会话会自动清空成员。</div>
    </el-form-item>
    <el-form-item
      v-if="form.sourceType === 6"
      label="成员白名单"
      prop="larkMembers"
    >
      <el-popover
        v-model="larkMemberCandidatesVisible"
        placement="bottom-start"
        popper-class="lark-candidate-popper"
        trigger="click"
        width="420"
        @show="resetLarkMemberCandidates"
      >
        <div v-if="larkCandidateMembers.length" class="telegram-candidate-list">
          <el-button
            v-for="item in larkCandidateMembers"
            :key="item.member_id"
            class="telegram-candidate-option"
            type="text"
            @click="toggleLarkMember(item)"
          >{{isLarkMemberSelected(item.member_id) ? '✓ ' : ''}}{{getLarkMemberLabel(item)}}</el-button>
        </div>
        <div v-else class="form-tip">{{larkMemberLoading ? '加载中...' : '暂无候选成员，请先选择群聊'}}</div>
        <el-button
          v-if="larkMemberHasMore"
          :disabled="larkMemberLoading"
          type="text"
          @click="loadLarkMembers"
        >加载更多</el-button>
        <div slot="reference" class="lark-member-reference">
          <el-tag
            v-for="member in form.larkMembers"
            :key="member.openId"
            closable
            size="small"
            @close="removeLarkMember(member.openId)"
          >{{member.name || member.openId}}</el-tag>
          <span v-if="!(form.larkMembers && form.larkMembers.length)" class="form-tip">点击选择群成员</span>
        </div>
      </el-popover>
      <div class="form-tip">留空表示采集整个群；选择成员则只采集所选成员。</div>
    </el-form-item>
    <el-form-item
      label="超时时间"
      prop="expirePeriod"
    >
      <el-input
        v-model="form.expirePeriod"
        placeholder="超时时间"
      >
        <template slot="append">分钟</template>
      </el-input>
    </el-form-item>
    <el-form-item
      label="匹配规则"
      prop="matchMode"
    >
      <el-radio-group
        v-model="form.matchMode"
      >
        <el-radio
          v-for="type in matchModeList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="form.matchMode==2"
      label="正则表达式"
      prop="pattern"
    >
      <el-input
        v-model="form.pattern"
        placeholder="正则表达式"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="策略备注"
      prop="remark"
    >
      <el-input
        v-model="form.remark"
        placeholder="策略备注"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio-group
        v-model="form.status"
      >
        <el-radio
          v-for="type in statusList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import quillEditor from "@/components/public/quillEditor";
import ossUploader from "@/components/public/ossUploader";
import {
  buildStrategyPayload,
  queryPersonalWxBotList,
  queryPersonalWxFriendsList, queryReptileStrategyList,
  queryWxPublicAccountFansList,
  queryWxPublicAccountList
} from "@/api/sys/statrgyManager/statrgyManager";
import {
  getTelegramCandidateChats,
  getTelegramCandidateMembers,
  getTelegramConfigList
} from '@/api/sys/robitConfig/telegram'
import {
  getLarkConfigList,
  getLarkGroupChatMembers,
  getLarkGroupChats
} from '@/api/sys/robitConfig/lark'
import { CascaderPanel } from 'element-ui'
let origin = {
  sourceType: 1,
  strategyName: '',
  sourceId: '',
  authorId: '',
  telegramMemberIds: '',
  larkMembers: [],
  expirePeriod: '',
  matchMode: 1,
  pattern: '',
  remark: '',
  status: 1,
}
export default {
  name: "statrgyArticleForm",
  components: {
    ElCascaderPanel: CascaderPanel,
    quillEditor,
    ossUploader,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  mixins: [formLabalPosition],
  data() {
    let _this = this;
    return {
      sourceTypeList:[
        {key:1,name:'微信公众号'},
        {key:2,name:'个人微信'},
        {key:3,name:'Webhook'},
        {key:4,name:'其他(爬虫)'},
        {key:5,name:'Telegram Bot'},
        {key:6,name:'Lark应用'}
      ],
      //策略来源 1.微信公众号列表 2个人微信机器人列表 3个人微信好友列表 4 爬虫策略列表
      wxPublicAccountList: [],//微信公众号列表
      personalWxBotList: [],//个人微信机器人列表
      reptileStrategyList: [],//爬虫策略列表
      telegramBotConfigList: [],//Telegram机器人配置列表
      telegramCandidateChats: [],
      telegramCandidateMembers: [],
      telegramChatDisplayCandidate: null,
      telegramMemberDisplayCandidates: [],
      telegramMemberSourceChatId: '',
      telegramCandidateChatRequestId: 0,
      telegramCandidateMemberRequestId: 0,
      telegramChatCandidatesVisible: false,
      telegramChatEditing: false,
      telegramChatCandidateType: null,
      telegramChatCandidateTypes: [
        {value: 2, label: '群组'},
        {value: 1, label: '私聊'},
      ],
      telegramChatCascaderKey: 0,
      telegramMemberCandidatesVisible: false,
      telegramMemberEditing: false,
      larkAppConfigList: [],//Lark应用配置列表
      larkCandidateChats: [],
      larkChatPageToken: '',
      larkChatHasMore: false,
      larkChatLoading: false,
      larkChatRequestId: 0,
      larkChatCandidatesVisible: false,
      larkChatEditing: false,
      larkChatDisplayCandidate: null,
      larkCandidateMembers: [],
      larkMemberPageToken: '',
      larkMemberHasMore: false,
      larkMemberLoading: false,
      larkMemberRequestId: 0,
      larkMemberCandidatesVisible: false,
      larkMemberSourceChatId: '',
      //作者来源列表
      wxPublicAccountFansList: [],//微信公众号粉丝列表,属于作者列表
      personalWxFriendsList: [],//个人微信好友列表,属于作者列表
      matchModeList:[
        {key:1,name:'无需匹配'},
        {key:2,name:'正则匹配'}
      ],
      statusList:[
        {key:1,name:'启用'},
        {key:0,name:'禁用'}
      ],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        sourceType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        strategyName: [
          { required:true, message: '请输入', trigger: 'blur'},
        ],
        sourceId: [
          _this.sourceIdRule,
        ],
        authorId: [
          _this.authIdRule,
        ],
        /* expirePeriod: [
           { required:true, message: '请输入', trigger: 'blur' },
         ],*/
        /* matchMode: [
           { required:true, message: '请选择', trigger: 'change' },
         ],*/
        /*pattern: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*remark: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*status: [
          { required:true, message: '请选择', trigger: 'change' },
        ]*/
      },
    }
  },
  computed: {
    strategySourceList() {
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return this.wxPublicAccountList;
        case 2:
          // 个人微信机器人列表
          return this.personalWxBotList;
        case 4:
          // 爬虫策略列表
          return this.reptileStrategyList;
        case 5:
          return this.telegramBotConfigList;
        case 6:
          return this.larkAppConfigList;
      }
    },
    authorList(){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return this.wxPublicAccountFansList;
        case 2:
          // 个人微信好友列表
          return this.personalWxFriendsList;
      }
    },
    authIdRule(){
      if(this.form.sourceType >= 3){
        return { required: true, message: '请完成', trigger: 'blur',}
      }else {
        return { required:true, message: '请完成', trigger: 'change',}
      }
    },
    sourceIdRule(){
      if(this.form.sourceType == 3){
        return { required:true, message: '请完成', trigger: 'blur'};
      }else {
        return { required:true, message: '请完成', trigger: 'change'};
      }
    },
    rulesComputed(){
      return {
        sourceType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        strategyName: [
          { required:true, message: '请输入', trigger: 'blur'},
        ],
        sourceId: [
          this.sourceIdRule,
        ],
        authorId: [
          ...(this.form.sourceType === 5 ? [
            { required: true, message: '请输入Telegram会话ID', trigger: 'blur' },
            { pattern: /^-?\d+$/, message: 'Telegram会话ID必须为整数', trigger: 'blur' },
          ] : []),
          ...(this.form.sourceType === 6 ? [
            { required: true, message: '请选择Lark群聊', trigger: 'blur' },
            { pattern: /^oc_/, message: 'Lark会话ID不合法，仅支持群聊chat_id（oc_开头）', trigger: 'blur' },
          ] : []),
        ],
        /* expirePeriod: [
           { required:true, message: '请输入', trigger: 'blur' },
         ],*/
        /* matchMode: [
           { required:true, message: '请选择', trigger: 'change' },
         ],*/
        /*pattern: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*remark: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*status: [
          { required:true, message: '请选择', trigger: 'change' },
        ]*/
      }
    },
    telegramChatCascaderProps(){
      return {
        emitPath: false,
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: this.loadTelegramChatCandidates,
      }
    },
    telegramChatDisplayText(){
      const chatId = String(this.form.authorId || '').trim();
      if(!chatId) return '';
      const item = this.telegramChatDisplayCandidate;
      const name = item && item.chatName && String(item.chatName) !== chatId
        ? item.chatName
        : '';
      return name ? `${name}（${chatId}）` : chatId;
    },
    telegramMemberDisplayText(){
      const ids = String(this.form.telegramMemberIds || '').trim()
        .split(/[\s,，]+/).filter(Boolean);
      if(!ids.length) return '';
      const candidates = this.telegramCandidateMembers.concat(this.telegramMemberDisplayCandidates);
      return ids.map(userId => {
        const item = candidates.find(candidate => String(candidate.userId) === userId);
        const name = item && (item.displayName || item.username);
        return name ? `${name}（${userId}）` : userId;
      }).join('\n');
    },
    larkChatDisplayText(){
      const chatId = String(this.form.authorId || '').trim();
      if(!chatId) return '';
      const item = this.larkChatDisplayCandidate;
      return item && item.name ? `${item.name}（${chatId}）` : chatId;
    },
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },

  created(){
    this.getWxPublicAccountList();

    this.getPersonalWxBotList();
    this.getReptileStrategyList();
    if(this.isAuth('wx:tgBotConfig:list')){
      this.getTelegramBotConfigList();
    }else {
      this.sourceTypeList = this.sourceTypeList.filter(item => item.key !== 5);
    }
    if(this.isAuth('wx:larkAppConfig:list')){
      this.getLarkAppConfigList();
    }else {
      this.sourceTypeList = this.sourceTypeList.filter(item => item.key !== 6);
    }

    //作者列表
    this.getWxPublicAccountFansList();

  },
  methods: {
    getStrategySourceLable(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return item.name;
        case 2:
          // 个人微信机器人列表
          return item.nickname;
        case 4:
          // 爬虫策略列表
          return item;
        case 5:
          return item.name;
        case 6:
          return item.appName;
      }
    },
    getStrategySourceValue(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return item.appid;
        case 2:
          // 个人微信机器人列表
          return item.id;
        case 4:
          // 爬虫策略列表
          return item;
        case 5:
          return String(item.id);
        case 6:
          return String(item.id);
      }
    },
    getAuthorLable(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return item.nickname;
        case 2:
          // 个人微信好友列表
          return item.nickname;
      }
    },
    getAuthorValue(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return item.openid;
        case 2:
          // 个人微信好友列表
          return item.id;
      }
    },
    //微信公众号列表
    getWxPublicAccountList(){
      queryWxPublicAccountList().then((res) => {
        console.log('公众号列表',res);
        this.wxPublicAccountList = res.page.list;
      })
    },
    //微信公众号粉丝列表this.form.sourceId
    getWxPublicAccountFansList(){
      queryWxPublicAccountFansList({
        page: 1,
        limit: 1000,
        appId: this.form.sourceType,
      }).then((res) => {
        if (res.code === 200) {

          this.wxPublicAccountFansList = res.page.list;
        } else {
          this.wxPublicAccountFansList = [];
        }
      })
    },
    //个人微信好友列表
    getPersonalWxFriendsList(){
      //逻辑有点问题,需要重新整理  todo
      queryPersonalWxFriendsList({
        page: 1,
        limit: 1000,
        botId: this.form.sourceId,
      }).then((res) => {
        console.log('个人微信好友列表',res.page.list);
        if(res.code === 200){
          this.personalWxFriendsList = res.page.list;
          console.log('个人微信好友列表this.data',this.personalWxFriendsList);
        }else {
          this.personalWxFriendsList = [];
        }
        console.log('personalWxFriendsList',this.personalWxFriendsList);
      })
    },
    sourceSelectChange(){
      this.form.authorId = '';
      if(this.form.sourceType === 5) {
        this.form.telegramMemberIds = '';
        this.telegramCandidateMembers = [];
        this.telegramChatDisplayCandidate = null;
        this.telegramMemberDisplayCandidates = [];
        this.telegramMemberSourceChatId = '';
        this.telegramChatEditing = false;
        this.telegramMemberEditing = false;
        this.telegramMemberCandidatesVisible = false;
        this.resetTelegramChatCandidateMenu();
      }
      if(this.form.sourceType === 6) {
        this.form.larkMembers = [];
        this.resetLarkState();
      }
      this.$refs.form.clearValidate(['authorId']);
      if(this.form.sourceType === 2) this.getPersonalWxFriendsList();
    },
    //个人微信机器人列表
    getPersonalWxBotList(){
      queryPersonalWxBotList({
        page: 1,
        limit: 1000,
        botStatus: 1,
      }).then((res) => {
        this.personalWxBotList = res.page.list;
      });
    },
    //爬虫策略列表
    getReptileStrategyList(){
      queryReptileStrategyList().then((res) => {
        if (res && res.code === 200) {
          this.reptileStrategyList = res.sourceNames;

        } else {
          this.reptileStrategyList=[]
        }
      })
    },
    getTelegramBotConfigList(page = 1, configs = [], scanned = 0){
      const limit = 1000;
      return getTelegramConfigList({
        page,
        limit,
        sidx: 'id',
        order: 'desc',
      }).then((res) => {
        if(!res || res.code !== 200 || !res.page){
          this.telegramBotConfigList = configs;
          return;
        }
        const rows = res.page.list || [];
        // 采集策略来源仅展示启用且具备采集能力的 bot（botRole=1 采集 / 3 两者）
        const merged = configs.concat(
          rows
            .filter(item => Number(item.status) === 1 && (item.botRole === 1 || item.botRole === 3))
            .map(item => ({
              id: item.id,
              name: item.name,
              status: item.status,
              botRole: item.botRole,
            }))
        );
        // 用累计原始行数比 totalCount：merged 是过滤后的，拿它比会多翻一页，
        // 且越界页若返回非空数据会翻不完。缺 totalCount 时按只有一页处理
        const total = Number(res.page.totalCount || 0);
        const seen = scanned + rows.length;
        if(rows.length && seen < total){
          return this.getTelegramBotConfigList(page + 1, merged, seen);
        }
        this.telegramBotConfigList = merged;
      }).catch(() => {
        // 保留已取到的页，避免请求失败时产生未处理的 rejection
        this.telegramBotConfigList = configs;
      })
    },
    getLarkAppConfigList(page = 1, configs = [], scanned = 0){
      const limit = 1000;
      return getLarkConfigList({
        page,
        limit,
        sidx: 'id',
        order: 'desc',
      }).then((res) => {
        if(!res || res.code !== 200 || !res.page){
          this.larkAppConfigList = configs;
          return;
        }
        const rows = res.page.list || [];
        // 采集策略来源仅展示启用且具备采集身份的应用（appRole=1 采集 / 3 两者）
        const merged = configs.concat(
          rows
            .filter(item => Number(item.status) === 1 && (item.appRole === 1 || item.appRole === 3))
            .map(item => ({
              id: item.id,
              appName: item.appName,
              status: item.status,
              appRole: item.appRole,
            }))
        );
        // 同上：lark 多一层 status 过滤，用 merged.length 比更容易多翻页
        const total = Number(res.page.totalCount || 0);
        const seen = scanned + rows.length;
        if(rows.length && seen < total){
          return this.getLarkAppConfigList(page + 1, merged, seen);
        }
        this.larkAppConfigList = merged;
      }).catch(() => {
        this.larkAppConfigList = configs;
      })
    },
    resetLarkChatCandidates(){
      this.larkCandidateChats = [];
      this.larkChatPageToken = '';
      this.larkChatHasMore = false;
      return this.loadLarkChats();
    },
    // Lark 游标式分页：透传上次响应的 page_token，has_more 时展示"加载更多"
    loadLarkChats(){
      const appConfigId = this.form.sourceId;
      if(this.form.sourceType !== 6 || !appConfigId ||
        (typeof this.isAuth === 'function' && !this.isAuth('wx:larkAppConfig:list'))){
        this.larkCandidateChats = [];
        this.larkChatHasMore = false;
        this.larkChatLoading = false;
        return Promise.resolve();
      }
      const requestId = (this.larkChatRequestId || 0) + 1;
      this.larkChatRequestId = requestId;
      this.larkChatLoading = true;
      return getLarkGroupChats(appConfigId, {
        pageToken: this.larkChatPageToken,
        pageSize: 100,
      }).then((res) => {
        if(requestId !== this.larkChatRequestId) return;
        this.larkChatLoading = false;
        if(!res || res.code !== 200 || !res.data) return;
        if(String(this.form.sourceId) !== String(appConfigId)) return;
        this.larkCandidateChats = this.larkCandidateChats.concat(res.data.items || []);
        this.larkChatPageToken = res.data.page_token || '';
        this.larkChatHasMore = !!res.data.has_more && !!this.larkChatPageToken;
        this.syncLarkChatDisplay();
      }).catch(() => {
        if(requestId === this.larkChatRequestId) this.larkChatLoading = false;
      })
    },
    syncLarkChatDisplay(){
      const chatId = String(this.form.authorId || '').trim();
      const chat = this.larkCandidateChats.find(item => String(item.chat_id) === chatId);
      if(chat || !this.larkChatDisplayCandidate ||
        String(this.larkChatDisplayCandidate.chat_id) !== chatId){
        this.larkChatDisplayCandidate = chat || null;
      }
    },
    selectLarkChat(item){
      this.larkChatEditing = false;
      this.larkChatCandidatesVisible = false;
      this.form.authorId = String(item.chat_id);
      this.larkChatDisplayCandidate = item;
      this.larkChatChange();
    },
    larkChatChange(){
      this.syncLarkChatDisplay();
      const chatId = String(this.form.authorId || '').trim();
      if(String(this.larkMemberSourceChatId || '') !== chatId){
        this.form.larkMembers = [];
        this.larkCandidateMembers = [];
        this.larkMemberPageToken = '';
        this.larkMemberHasMore = false;
        this.larkMemberCandidatesVisible = false;
      }
      this.larkMemberSourceChatId = chatId;
    },
    larkChatInputChange(value){
      this.form.authorId = value;
      this.syncLarkChatDisplay();
    },
    getLarkChatLabel(item){
      return item.name ? `${item.name} (${item.chat_id})` : String(item.chat_id);
    },
    resetLarkMemberCandidates(){
      this.larkCandidateMembers = [];
      this.larkMemberPageToken = '';
      this.larkMemberHasMore = false;
      return this.loadLarkMembers();
    },
    loadLarkMembers(){
      const appConfigId = this.form.sourceId;
      const chatId = String(this.form.authorId || '').trim();
      if(this.form.sourceType !== 6 || !appConfigId || chatId.indexOf('oc_') !== 0 ||
        (typeof this.isAuth === 'function' && !this.isAuth('wx:larkAppConfig:list'))){
        this.larkCandidateMembers = [];
        this.larkMemberHasMore = false;
        this.larkMemberLoading = false;
        return Promise.resolve();
      }
      const requestId = (this.larkMemberRequestId || 0) + 1;
      this.larkMemberRequestId = requestId;
      this.larkMemberLoading = true;
      return getLarkGroupChatMembers(appConfigId, chatId, {
        pageToken: this.larkMemberPageToken,
        pageSize: 100,
      }).then((res) => {
        if(requestId !== this.larkMemberRequestId) return;
        this.larkMemberLoading = false;
        if(!res || res.code !== 200 || !res.data) return;
        if(String(this.form.sourceId) !== String(appConfigId) ||
          String(this.form.authorId || '').trim() !== chatId) return;
        this.larkCandidateMembers = this.larkCandidateMembers.concat(res.data.items || []);
        this.larkMemberPageToken = res.data.page_token || '';
        this.larkMemberHasMore = !!res.data.has_more && !!this.larkMemberPageToken;
      }).catch(() => {
        if(requestId === this.larkMemberRequestId) this.larkMemberLoading = false;
      })
    },
    isLarkMemberSelected(memberId){
      const openId = String(memberId || '');
      return (this.form.larkMembers || []).some(member => member.openId === openId);
    },
    toggleLarkMember(item){
      const openId = String(item.member_id || '').trim();
      if(!openId) return;
      const members = this.form.larkMembers || [];
      this.form.larkMembers = members.some(member => member.openId === openId)
        ? members.filter(member => member.openId !== openId)
        : members.concat({openId, name: item.name || ''});
    },
    removeLarkMember(openId){
      this.form.larkMembers = (this.form.larkMembers || []).filter(member => member.openId !== openId);
    },
    getLarkMemberLabel(item){
      return item.name ? `${item.name} (${item.member_id})` : String(item.member_id);
    },
    selectTelegramChatCandidateType(candidateType){
      this.telegramChatCandidateType = candidateType;
      return this.getTelegramCandidateChats(1, [], this.form.sourceId, undefined, candidateType);
    },
    loadTelegramChatCandidates(node, resolve){
      return this.selectTelegramChatCandidateType(node.value).then(candidates => {
        resolve((candidates || []).map(item => ({
          value: String(item.chatId),
          label: this.getTelegramChatLabel(item),
          leaf: true,
          candidate: item,
        })));
      });
    },
    resetTelegramChatCandidateMenu(){
      this.telegramChatCandidateType = null;
      this.telegramCandidateChats = [];
      this.telegramChatCascaderKey++;
      this.telegramCandidateChatRequestId = (this.telegramCandidateChatRequestId || 0) + 1;
    },
    getTelegramCandidateChats(page = 1, candidates = [], botConfigId = this.form.sourceId, requestId,
                              candidateType = this.telegramChatCandidateType){
      candidateType = Number(candidateType);
      if(page === 1){
        requestId = (this.telegramCandidateChatRequestId || 0) + 1;
        this.telegramCandidateChatRequestId = requestId;
        this.telegramCandidateChats = [];
      }
      if(this.form.sourceType !== 5 || !botConfigId || ![1, 2].includes(candidateType) ||
        (typeof this.isAuth === 'function' && !this.isAuth('wx:tgBotConfig:list'))){
        this.telegramCandidateChats = [];
        return Promise.resolve([]);
      }
      const limit = 1000; // ponytail: bound the dropdown; add keyword paging if this ceiling is reached.
      return getTelegramCandidateChats(botConfigId, {page, limit, candidateType}).then((res) => {
        if(!res || res.code !== 200 || !res.page){
          if(requestId === this.telegramCandidateChatRequestId){
            this.telegramCandidateChats = [];
          }
          return [];
        }
        const merged = candidates.concat(res.page.list || []);
        const filtered = merged.filter(item => Number(item.candidateType) === candidateType);
        if(requestId === this.telegramCandidateChatRequestId &&
          String(this.form.sourceId) === String(botConfigId) && this.telegramChatCandidateType === candidateType){
          this.telegramCandidateChats = filtered;
          this.syncTelegramChatDisplay();
        }
        return filtered;
      }).catch(() => {
        if(requestId === this.telegramCandidateChatRequestId &&
          String(this.form.sourceId) === String(botConfigId) && this.telegramChatCandidateType === candidateType){
          this.telegramCandidateChats = [];
        }
        return [];
      })
    },
    getTelegramCandidateMembers(page = 1, candidates = [], botConfigId = this.form.sourceId, chatId = this.form.authorId, requestId){
      if(page === 1){
        requestId = (this.telegramCandidateMemberRequestId || 0) + 1;
        this.telegramCandidateMemberRequestId = requestId;
        this.telegramCandidateMembers = [];
      }
      if(this.form.sourceType !== 5 || !botConfigId || !chatId ||
        (typeof this.isAuth === 'function' && !this.isAuth('wx:tgBotConfig:list'))){
        this.telegramCandidateMembers = [];
        return Promise.resolve();
      }
      const limit = 1000; // ponytail: bound the dropdown; add keyword paging if this ceiling is reached.
      return getTelegramCandidateMembers(botConfigId, chatId, {page, limit}).then((res) => {
        if(!res || res.code !== 200 || !res.page){
          if(requestId === this.telegramCandidateMemberRequestId) this.telegramCandidateMembers = [];
          return;
        }
        const merged = candidates.concat(res.page.list || []);
        if(requestId !== this.telegramCandidateMemberRequestId) return;
        if(String(this.form.sourceId) === String(botConfigId) && String(this.form.authorId) === String(chatId)){
          this.telegramCandidateMembers = merged;
        }
      }).catch(() => {
        if(requestId === this.telegramCandidateMemberRequestId &&
          String(this.form.sourceId) === String(botConfigId) && String(this.form.authorId) === String(chatId)){
          this.telegramCandidateMembers = [];
        }
      })
    },
    getSelectedTelegramChat(){
      return this.telegramCandidateChats.find(item => String(item.chatId) === String(this.form.authorId));
    },
    syncTelegramChatDisplay(){
      const chat = this.getSelectedTelegramChat();
      if(chat || !this.telegramChatDisplayCandidate ||
        String(this.telegramChatDisplayCandidate.chatId) !== String(this.form.authorId)){
        this.telegramChatDisplayCandidate = chat || null;
      }
    },
    isSelectedPrivateTelegramChat(){
      const chat = this.getSelectedTelegramChat();
      if(chat) return chat.candidateType === 1;
      return /^[1-9]\d*$/.test(String(this.form.authorId || '').trim());
    },
    telegramChatChange(){
      this.syncTelegramChatDisplay();
      const chatId = String(this.form.authorId || '').trim();
      if(String(this.telegramMemberSourceChatId || '') !== chatId){
        this.form.telegramMemberIds = '';
        this.telegramCandidateMembers = [];
        this.telegramMemberDisplayCandidates = [];
        this.telegramMemberCandidatesVisible = false;
      }
      this.telegramMemberSourceChatId = chatId;
      const chat = this.getSelectedTelegramChat();
      const isGroup = chat
        ? chat.candidateType === 2
        : /^-\d+$/.test(String(this.form.authorId || '').trim());
      return isGroup
        ? this.getTelegramCandidateMembers()
        : Promise.resolve();
    },
    getTelegramChatLabel(item){
      return item.chatName && String(item.chatName) !== String(item.chatId)
        ? `${item.chatName} (${item.chatId})`
        : String(item.chatId);
    },
    getTelegramMemberLabel(item){
      const name = item.displayName || item.username;
      return name ? `${name} (${item.userId})` : String(item.userId);
    },
    updateTelegramMemberPopover(){
      this.$nextTick(() => {
        const input = this.$refs.telegramMemberInput;
        if(input) input.resizeTextarea();
        const popover = this.$refs.telegramMemberCandidatesPopover;
        if(this.telegramMemberCandidatesVisible && popover) popover.updatePopper();
      });
    },
    telegramChatInputChange(value){
      this.form.authorId = value;
      this.syncTelegramChatDisplay();
    },
    telegramChatSelect(item){
      this.telegramChatEditing = false;
      this.form.authorId = String(item.chatId);
      this.telegramChatDisplayCandidate = item;
      this.syncTelegramChatDisplay();
      this.telegramChatCandidatesVisible = false;
      return this.telegramChatChange();
    },
    telegramChatCascaderSelect(){
      const nodes = this.$refs.telegramChatCascader.getCheckedNodes(true);
      if(nodes.length && nodes[0].data.candidate){
        return this.telegramChatSelect(nodes[0].data.candidate);
      }
    },
    addTelegramMember(userId){
      if(!userId) return;
      const values = String(this.form.telegramMemberIds || '').trim()
        .split(/[\s,，]+/).filter(Boolean);
      this.form.telegramMemberIds = Array.from(new Set(values.concat(String(userId)))).join('\n');
      this.telegramMemberEditing = false;
      this.telegramMemberCandidatesVisible = false;
    },
    telegramMemberInputChange(value){
      this.form.telegramMemberIds = value;
      this.updateTelegramMemberPopover();
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
      this.telegramChatCandidatesVisible = false;
      this.resetTelegramChatCandidateMenu();
      this.telegramCandidateMembers = [];
      this.telegramChatDisplayCandidate = null;
      this.telegramMemberDisplayCandidates = [];
      this.telegramMemberSourceChatId = '';
      this.telegramChatEditing = false;
      this.telegramMemberEditing = false;
      this.telegramMemberCandidatesVisible = false;
      this.resetLarkState();
    },
    resetLarkState(){
      this.larkCandidateChats = [];
      this.larkCandidateMembers = [];
      this.larkChatPageToken = '';
      this.larkChatHasMore = false;
      this.larkChatLoading = false;
      this.larkMemberPageToken = '';
      this.larkMemberHasMore = false;
      this.larkMemberLoading = false;
      this.larkChatDisplayCandidate = null;
      this.larkMemberSourceChatId = '';
      this.larkChatEditing = false;
      this.larkChatCandidatesVisible = false;
      this.larkMemberCandidatesVisible = false;
      this.larkChatRequestId = (this.larkChatRequestId || 0) + 1;
      this.larkMemberRequestId = (this.larkMemberRequestId || 0) + 1;
    },
    assigen(data){
      // todo
      this.form.id = data.id;
      this.form = {
        ...data,
        telegramMemberIds: data.sourceType === 5
          ? (data.telegramMembers || []).map(item => String(item.userId)).join('\n')
          : '',
        larkMembers: data.sourceType === 6
          ? (data.larkMembers || []).map(item => ({
              openId: String(item.openId || ''),
              name: item.name || '',
            }))
          : [],
      };
      this.telegramCandidateMembers = [];
      this.telegramChatDisplayCandidate = null;
      this.telegramChatEditing = false;
      this.telegramMemberEditing = false;
      this.telegramMemberSourceChatId = data.sourceType === 5
        ? String(data.authorId || '').trim()
        : '';
      this.resetLarkState();
      this.larkMemberSourceChatId = data.sourceType === 6
        ? String(data.authorId || '').trim()
        : '';
      this.telegramMemberDisplayCandidates = data.sourceType === 5
        ? (data.telegramMembers || []).slice()
        : [];
      this.telegramChatCandidatesVisible = false;
      this.resetTelegramChatCandidateMenu();
      this.telegramMemberCandidatesVisible = false;
      if(data.sourceType === 1) this.getWxPublicAccountFansList();
      if(data.sourceType === 2) this.getPersonalWxFriendsList();
      if(data.sourceType === 5 && /^-?\d+$/.test(String(data.authorId || '').trim())){
        const candidateType = String(data.authorId).trim().startsWith('-') ? 2 : 1;
        const requests = [this.selectTelegramChatCandidateType(candidateType)];
        if(candidateType === 2) requests.push(this.getTelegramCandidateMembers());
        return Promise.all(requests).then(() => this.syncTelegramChatDisplay());
      }
      // 编辑回显：拉一页候选群聊，把裸 chat_id 解析成群名（loadLarkChats 成功后会 syncLarkChatDisplay）
      // ponytail: 只覆盖首页 100 个群；超出需后端提供按 chat_id 查单群的接口
      if(data.sourceType === 6) return this.resetLarkChatCandidates();
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          if(!this.form.authorId){
            this.$message.error('请输入或者选择策略作者');
            return;
          }
          try {
            this.$emit('submit',buildStrategyPayload(this.form));
          } catch (error) {
            this.$message.error(error.message);
          }
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
      this.reset();
    },
    catchData(content){
      this.form.contentEdit = content;
    },
    sourceTypeChange(){
      this.form.sourceId = '';
      this.form.authorId = '';
      this.form.telegramMemberIds = '';
      this.form.larkMembers = [];
      this.resetLarkState();
      this.telegramCandidateChats = [];
      this.telegramCandidateMembers = [];
      this.telegramChatDisplayCandidate = null;
      this.telegramMemberDisplayCandidates = [];
      this.telegramMemberSourceChatId = '';
      this.telegramChatEditing = false;
      this.telegramMemberEditing = false;
      this.telegramChatCandidatesVisible = false;
      this.resetTelegramChatCandidateMenu();
      this.telegramMemberCandidatesVisible = false;
      if(this.form.sourceType === 1) this.getWxPublicAccountFansList();
      this.$refs.form.clearValidate();
    }
  },
}
</script>

<style lang="scss" scoped>
.statrgy-manager-form {
  /deep/ .el-radio-group {
    padding-top: 15px;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
    .el-radio {
      margin-bottom: 10px;
    }
  }
  .form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 20px;
  }
  /deep/ .el-popover__reference-wrapper {
    display: block;
  }
  .lark-member-reference {
    min-height: 36px;
    padding: 4px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    line-height: 26px;
    .el-tag {
      margin-right: 6px;
    }
  }
}
</style>

<style lang="scss">
.telegram-candidate-popper,
.lark-candidate-popper {
  .telegram-candidate-list {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-height: 240px;
    overflow-y: auto;
  }
  .telegram-candidate-option {
    display: block;
    margin: 0;
    width: 100%;
    text-align: left;
  }
  .telegram-candidate-option + .telegram-candidate-option {
    margin-left: 0;
  }
}
</style>
